import React from 'react'
import { Link } from 'react-router-dom'

import { request } from 'Lib/axios'
import { CookieHelper } from 'Utils/cookieHelper'
import { PARAMS_COOKIE_KEYS } from 'Consts/cookies.enum'

import { utils } from '@clickcease/cc-client-components-lib'
import { useMutation, useQueryClient } from '@tanstack/react-query'
import { AxiosError } from 'axios'

import { useUserStore } from 'Stores/userStoreModuleFed'
import { useAppStore } from 'Stores/appStoreModuleFed'
import { useZendeskChat } from 'Hooks/zendesk/useZendeskChat'
import { TOASTS } from 'Components/Elements/Toaster/Toast.models'

export const useUpdatePlan = () => {
  const queryClient = useQueryClient()
  const { showSystemMessage } = useAppStore()
  const { setSubscription } = useUserStore()
  const { updateLogicCookieData } = CookieHelper()
  const { openChat } = useZendeskChat()

  const handleError = (error: AxiosError) => {
    const message = utils.get(error, 'response.data.message', '') as string
    if (message === 'INVALID_PAYMENT_METHOD') {
      showSystemMessage(
        {
          i18nKey: `system_messages.INVALID_PAYMENT_METHOD`,
          components: { support: <Link to="#" onClick={openChat} /> },
        },
        TOASTS.failure
      )
    }
  }

  return useMutation(updatePlan, {
    onSuccess: (res) => {
      if (!(res instanceof Error)) {
        setSubscription(res.data.subscriptionId)
        updateLogicCookieData(PARAMS_COOKIE_KEYS.SUBSCRIPTION_ID, `${res.data.subscriptionId}`)
        void queryClient.invalidateQueries({ queryKey: ['getPackagesLimits'] })
        void queryClient.invalidateQueries({ queryKey: ['accountSettings'] })
        void queryClient.invalidateQueries({ queryKey: ['getPlansDetails'] })
        void queryClient.invalidateQueries({ queryKey: ['accountUsage'] })
        void queryClient.invalidateQueries({ queryKey: ['domains'] })
        void queryClient.invalidateQueries({ queryKey: ['checkoutSummary'] })
      } else handleError(res)
    },
    onError: (error: AxiosError) => handleError(error),
  })
}

const updatePlan = async (params: {
  products: Array<number>
  hideErrorToaster: boolean
  token?: string
}) => {
  const accountId = useUserStore.getState().accountId

  return request<{ data: { subscriptionId: number } }>({
    url: `accounts/${accountId}/subscriptions`,
    method: 'PUT',
    data: { products: params.products, override: true, token: params.token },
    hideErrorToaster: params.hideErrorToaster,
  })
}
